import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import './App.css';
import LoginForm from './HomeMgmt/LoginForm';
import ClientDetailsForm from './ClientMgmt/ClientDetailsForm';
import LoanDisbursement from './LoanMgmt/LoanDisbursement';
import LoanRepayment from './LoanMgmt/LoanRepayment';
import RepaymentReport from './Reports/RepaymentReport';
import AdvanceRepaymentReport from './Reports/AdvanceRepaymentReport';
import CenterMgmt from './CenterMgmt';
import LoanRepaymentList from './LoanMgmt/LoanRepaymentList';
import ClientManagement from './ClientMgmt';
import Dashboard from './Dashboard';
import { AuthProvider, useAuth } from './AuthContext';

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

function AppContent() {
  const { isAuthenticated, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <Router>
      <div className="app-container">
        {isAuthenticated && (
          <>
            <div className="mobile-header">
              <button className="hamburger" onClick={toggleSidebar}>
                ☰
              </button>
              <h2>Dashboard</h2>
            </div>

            <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
              <div className="logo">
                <h2>Menu</h2>
              </div>
              <ul className="menu">
                <li><Link to="/centers" onClick={toggleSidebar}>Center Management</Link></li>
                <li><Link to="/clients" onClick={toggleSidebar}>Client Management</Link></li>
                <li><Link to="/loan-disbursement" onClick={toggleSidebar}>Disbursement Management</Link></li>
                <li><Link to="/loan-repayment-list" onClick={toggleSidebar}>Repayment Management</Link></li>
                <li><Link to="/loan-repayment" onClick={toggleSidebar}>Loan Repayment</Link></li>
                <li><Link to="/repayment-report" onClick={toggleSidebar}>Repayment Report</Link></li>
                <li><Link to="/advance-repayment-report" onClick={toggleSidebar}>Advance Repayment Report</Link></li>
                <li><button onClick={() => { logout(); setSidebarOpen(false); }} className="logout-button">Logout</button></li>
              </ul>
            </div>
          </>
        )}

        <div className="content">
          <Routes>
            <Route path="/login" element={!isAuthenticated ? <LoginForm /> : <Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} />
            <Route path="/centers" element={isAuthenticated ? <CenterMgmt /> : <Navigate to="/login" />} />
            <Route path="/clients" element={isAuthenticated ? <ClientManagement /> : <Navigate to="/login" />} />
            <Route path="/client-details" element={isAuthenticated ? <ClientDetailsForm /> : <Navigate to="/login" />} />
            <Route path="/loan-disbursement" element={isAuthenticated ? <LoanDisbursement /> : <Navigate to="/login" />} />
            <Route path="/loan-repayment-list" element={isAuthenticated ? <LoanRepaymentList /> : <Navigate to="/login" />} />
            <Route path="/loan-repayment" element={isAuthenticated ? <LoanRepayment /> : <Navigate to="/login" />} />
            <Route path="/repayment-report" element={isAuthenticated ? <RepaymentReport /> : <Navigate to="/login" />} />
            <Route path="/advance-repayment-report" element={isAuthenticated ? <AdvanceRepaymentReport /> : <Navigate to="/login" />} />
            <Route path="/" element={<Navigate to="/login" />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
